var selectNav = document.getElementById("selectNav");

if(typeof(selectNav) != 'undefined' && selectNav != null){

    selectNav.onchange = function(e) {

        e.preventDefault()

        var elem = (typeof this.selectedIndex === "undefined" ? window.event.target : this);
        var value = elem.value || elem.options[elem.selectedIndex].value;

        window.location.href = value;
    }
    
} else{
    // console.log("No mobile select nav on this page")
}